import { ProductImageResponse } from './productImagesModel';
import { PostingProfileResponse } from '../features/posting-profile/models/strategiesModel';

export class BaseProductMarketPlaceLisitngRequest {
  id: number = 0;
  productId: number = 0;
  listingId: number = 0;
  offerId: number = 0;
  defaultCarrierId: number = 0;
  notes: string = '';
  expireAt: Date = new Date();
  scheduleAt: Date = new Date();
  status: string = '';
  failedReason: string = '';
  marketplaceResponse: string = '';
  type: string = '';
  startingBid: number = 0;
  bidIncrement: number = 0;
  reservePrice: number = 0;
  buyNowPrice: number = 0;
  marketplace: number = 0;
  account: string = '';
  postingProfile: string = '';
  accessToken: string = '';
  companyId: number = 0;
  product: Product = new Product();
}

export class CreateProductMarketPlaceLisitngRequest extends BaseProductMarketPlaceLisitngRequest {}

export class ProductMarketPlaceLisitngResponse extends BaseProductMarketPlaceLisitngRequest {
  createdAt: Date = new Date();
  createdById: number = 0;
  lastModifiedAt: Date = new Date();
  lastModifiedById: number = 0;
}
export class PaginatedProductMarketPlaceLisitngsResponse {
  totalCount: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  items: ProductMarketPlaceLisitngResponse[] = [];
}

export class Product {
  name: string = '';
  sku: string = '';
  description: string = '';
  inventoryLocationId: number = 0;
  serialNumber: string = '';
  barCode: string = '';
  productStatus: number = 0;
  supplierName: string = '';
  productImages: ProductImageResponse[] = [];
}

export class Marketplace {
  id: number = 0;
  name: string = '';
}
export class productPostingProfileRuleMapping {
  productId: number = 0;
  postingProfileRuleId: number = 0;
  buyNowPrice: number = 0;
  reservePrice: number = 0;
  startingBid: number = 0;
  bidIncrement: number = 0;
  salesFloorPrice: number = 0;
  handlingCharges: number = 0;
  postingProfileRule: PostingProfileResponse = new PostingProfileResponse();
}
export enum ProductMarketplaceListingStatus {
  Waiting,
  InProgress,
  Listed,
  Failed,
  Sold,
  Closed,
  Expired,
}
